
import React, { useState, useEffect } from 'react';
import moment  from 'moment';
import DatePicker from "react-datepicker";
import { registerLocale } from  "react-datepicker";
import ru from 'date-fns/locale/ru';
import styled from 'styled-components';
import {
  TextField,
  InputAdornment,
  IconButton
} from '@material-ui/core'
import ClearIcon from '@material-ui/icons/Clear';
import CalendarTodayOutlined from '@material-ui/icons/CalendarTodayOutlined';
import { IMaskInput } from 'react-imask';

registerLocale('ru', ru);

const Wrapper = styled.div`
  .react-datepicker-wrapper {
    display: block !important;
  }
  
  .react-datepicker-popper {
    z-index: 20;
  }
`;

function DateMaskInput(props) {
  return (
    <IMaskInput
      {...props}
      mask={Date}
      lazy={false}
    />
  );
}

export default function DateMaskedWidget(
  {
    value,
    onChange,
    label,
    size = 'medium',
    shrink = true,
    disabled = false,
    popperPlacement = 'bottom-start',
    wrapperClassName = undefined
  }) {
  const [widgetValue, setWidgetValue] = useState();
  const refMaskedValue = React.useRef('');

  useEffect(() => {
    if (value && moment(value).isValid()) {
      setWidgetValue(moment(value).toDate());
    }
    else {
      setWidgetValue(null);
      refMaskedValue.current = '';
    }
  }, [value]);

  const handleChange = (newValue) => {
    if (newValue) {
      onChange(moment(newValue).format('YYYY-MM-DD'), newValue);
      setWidgetValue(newValue);
    }
    else {
      onChange(null, null);
      setWidgetValue(null);
    }
  }

  const clearValue = () => {
    setWidgetValue(null);
    onChange(null, null);
  }

  const handleBlur = () => {
    if (refMaskedValue.current === '' || refMaskedValue.current === '__.__.____') {
      if (widgetValue !== null) {
        handleChange(null);
      }
    }
    else if (moment(refMaskedValue.current, 'DD.MM.YYYY', true).isValid()) {
      if (!moment(refMaskedValue.current, 'DD.MM.YYYY').isSame(widgetValue, 'day')) {
        handleChange(moment(refMaskedValue.current, 'DD.MM.YYYY').toDate());
      }
    }
  }

  const handleKeyDown = (e) => {
    if(e.keyCode === 13) {
       handleBlur();
    }
 }

  const MaterialInput = React.forwardRef(( props, ref ) => {
    return (
      <TextField
        value={props.value}
        label={label}
        size={size}
        fullWidth={true}
        disabled={disabled}
        variant="outlined"
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        InputProps={{
          inputComponent: DateMaskInput,
          inputProps: {
            onAccept: (value, mask) => refMaskedValue.current = value
          },
          startAdornment: (
            <InputAdornment position="start">
              <IconButton onClick={props.onClick} disabled={disabled} size={'small'}>
                <CalendarTodayOutlined />
              </IconButton>
            </InputAdornment>
          ),
          endAdornment: (
            (value && (
              <InputAdornment position="end">
                <IconButton onClick={clearValue} disabled={disabled} size={'small'}>
                  <ClearIcon />
                </IconButton>
              </InputAdornment>
            ))
          ),
        }}
        InputLabelProps={{ shrink: shrink }}
      />
    )
  });

  return (
    <Wrapper className={wrapperClassName}>
      <DatePicker
        selected={widgetValue}
        onChange={date => handleChange(date)}
        customInput={<MaterialInput />}
        disabled={disabled}
        locale="ru"
        showPopperArrow={false}
        popperPlacement={popperPlacement}
        dateFormat="dd.MM.yyyy"
      />
    </Wrapper>
  )
}
